import SimpleMdeReact from "react-simplemde-editor";
import { Col } from "reactstrap";
import { P } from "../../../../../../AbstractElements";
import { MdeEditorText } from "../../../../../../Constants/Constants";

const FormEditors = () => {
  return (
    <Col xs="12">
      <div className="toolbar-box">
        <div id="toolbar2">
          <SimpleMdeReact id="editor_container" placeholder={MdeEditorText} options={{ autofocus: false, spellChecker: true }} />
        </div>
      </div>
      <P className="f-light">{"Improve product visibility by adding a compelling description."}</P>
    </Col>
  );
};

export default FormEditors;
